import type { RouteRecordRaw } from 'vue-router'

import { TopNews } from './news'
import { route as notFoundRoute } from './not-found'
import { Login } from './auth'
import { Users } from './user'
import { Organizations } from './organization'
import { Cashes } from './cash'
import { Regions } from './region'
import { Warehouses } from './warehouse'
import { Roles } from './role'
import { Metadatas } from './metadata'
import { Inventories } from './inventory'
import { SupplierContracts } from './supplier-contract'
import { StoreIns } from './store-in'
import { StoreWriteOffs } from './store-write-off'
import { Stores } from './store'
import { StoreChecks } from './store-check'
import { StoreChanges } from './store-change'
import { Dashboard } from './dashboard'
import { Promotions } from './promotion'
import { Customers } from './customer'
import { CustomerTypes } from './customer-type'
import { InventoryTypes } from './inventory-type'
import { Orders } from './order'
import { CustomerGroups } from './customer-group'
import { InventoryGroups } from './inventory-group'
import { TelegramBotUsers } from './telegram-bot-user'
import { PriceTypes } from './price-type'
import { DiscountMarkups } from './discount-markups'
import { OrderReturns } from './order-return'

export const routes: readonly RouteRecordRaw[] = [
  TopNews,
  notFoundRoute,
  Login,
  Metadatas,
  Users,
  Organizations,
  Cashes,
  Regions,
  Warehouses,
  Roles,
  Inventories,
  SupplierContracts,
  StoreIns,
  StoreWriteOffs,
  Stores,
  StoreChecks,
  StoreChanges,
  Dashboard,
  Promotions,
  Customers,
  CustomerTypes,
  InventoryTypes,
  Orders,
  CustomerGroups,
  InventoryGroups,
  TelegramBotUsers,
  PriceTypes,
  DiscountMarkups,
  OrderReturns,
] as const
